module.exports = __webpack_public_path__ + "img/200-produtos.995540c2.jpeg";